import { RestUrl } from "../common/cyan.types";

export class DocumentSignUrl {
  public static paginateDocumentSigns: RestUrl = ["GET", "/document-signs"];
  public static getDocumentSign: (id: bigint) => RestUrl = id => ["GET", `/document-signs/${id}`];
  public static createDocumentSign: RestUrl = ["POST", "/document/signs"];
  public static cancelDocumentSign: (documentSignId: bigint) => RestUrl = documentSignId => [
    "POST",
    `/document/signs/${documentSignId}/cancel`,
  ];
  public static cancelDocumentSigns: RestUrl = ["POST", "/document-signs/cancel/bulk"];
  public static getDocumentSignDocsPdfPage: (documentSignId: bigint) => RestUrl = documentSignId => [
    "GET",
    `/document-sign/signs/${documentSignId}/docs-pdf/page`,
  ];
}
